import RouteTemplate from 'ember-route-template';
import { PageLoading } from 'embroil/components/loading';

export default RouteTemplate(
  <template>
  <PageLoading 
    @message="Loading content..." 
    @subtitle="Please wait while we fetch the latest data"
    class="global-loading"
  />
</template>
);